/* eslint-disable @typescript-eslint/no-explicit-any */
import { Game } from "@/interfaces/Game";
import { dateStandardFormat, secondsToTime, timeStandardFormat } from "@/utils/helpers";
import axios from "axios";
import { computed, ref } from "vue";

declare type Info = { dt: string; today: boolean; usa: boolean; results: Game[]; seconds: number };

export const useDisplay = (url: string) => {
  const index = ref(-1);
  const results = ref<Info[]>([]);
  const currents = ref<Info | undefined>();
  const wakelock = ref<WakeLockSentinel | undefined>();
  const dteRef = ref(new Date());
  const changeOnRef = ref(0);

  const updateCurrent = () => {
    if (results.value.length) {
      index.value++;
      if (index.value >= results.value.length) {
        index.value = 0;
      }

      currents.value = results.value[index.value];
    } else {
      index.value = 0;
      currents.value = undefined;
    }
  };

  if ("wakeLock" in navigator) {
    navigator.wakeLock.request("screen").then((wakelockObj: WakeLockSentinel) => {
      wakelock.value = wakelockObj;
    });
  }

  return {
    wakelock,
    currents,
    dteRef,
    changeOnRef,
    changeOnComputed: computed(() => secondsToTime(changeOnRef.value)),
    dteComputed: computed(() => timeStandardFormat(dteRef.value)),
    date: computed(() => (currents.value ? dateStandardFormat(currents.value.dt) : "")),
    isToday: computed(() => currents.value?.today === true),
    isUsa: computed(() => currents.value?.usa === true),
    updateCurrent,
    getInfo: async () => {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const response = await axios.get<Info[]>(url, { params: { tz } });

      if (response.data) {
        results.value = response.data;

        updateCurrent();
      }
    },
  };
};
